import { SkillForm } from "@/core/skillForms/types";
import { createLaborInitialPetitionSkillStep2 } from "../createLaborInitialPetitionSkill/step2";

export const createLaborComplaintSkillForm: SkillForm = {
  skillId: "create_labor_complaint",
  title: "Escrever reclamação trabalhista",
  steps: [createLaborInitialPetitionSkillStep2],
  lastStepSubmitButtonText: "Criar Petição Inicial",
};
